import { Grid, Text, useTheme } from '@chakra-ui/react';
import { useAppContext } from '../../App';

export const CustomGrid = ({title = '', iteratedComponent, items, customStyles = {}}) => {
  const { isMobile } = useAppContext();
  const theme = useTheme();
  const style = styles(theme, isMobile, customStyles);
  return (
    <div style={style.container} className='quicksand-semibold'>
      {
        title &&
        <Text {...customStyles.title}>
          {title}
        </Text>
      }
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
        gap={12}
        pl={0}
        pr={0}
        w={"80%"}
        {...customStyles.grid}
      >
        {items.map((item, index) => (
          iteratedComponent({item, index})
        ))}
      </Grid>
    </div>
  );
};

const styles = (theme, isMobile, customStyles) => ({
  container: {
    display:'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: "5vh",
    backgroundColor: theme.background.primary,
    ...customStyles.container
  },
});
